<template>
    <form-save 
        modelName="Categoria" 
        saveUrl="theme-categories/" 
        operation="post"
        id=""
        backUrl="/theme-categories"
        icon="fa-list-ul"
        ></form-save>
</template>

<script>
import FormSave from "./FormSave";
export default {
  components: {
    FormSave
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/ThemeCategory/Add.vue